import { ACCESS_TOKEN, PIXEL_ID } from "application/utils/constants";

const TRACKING_DEBUG =
  window.location.href.includes("debugGA") ||
  window.location.href.includes("debugTracking") ||
  window.location.href.includes("localhost");

export async function sendEventToMetaCapiService(sendEvent: any) {
  const url = `https://graph.facebook.com/v17.0/${PIXEL_ID}/events?access_token=${ACCESS_TOKEN}`;
  if (TRACKING_DEBUG) {
    console.info("Sending Meta CAPI event:", sendEvent);
  }

  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(sendEvent),
  });

  if (!response.ok) {
    const error = await response.json();
    console.error("Meta CAPI Error:", error);
    throw new Error(error.error?.message || "Failed to send Meta event");
  }
  return response.json();
}